module.exports = __webpack_public_path__ + "static/media/alert-circle-info.94e0a995.svg";